import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CorporateSubmissionPage.css';
import {
  Card,
  Space,
  Select,
  Form,
  Input,
  InputNumber,
  DatePicker,
  Button,
  Row,
  Col,
  Collapse,
  Upload,
  Typography,
  Spin,
  Descriptions,
  Divider,
  Checkbox,
  Table,
  Switch,
  Image,
  Modal,
  notification,
} from 'antd';
import {
  authPersonFormFields,
  companyOwnerFormFields,
  directorFormFields,
  fieldToPanelMappingForCorporateTrader,
  uploadFields,
} from './Constants';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { UploadOutlined, ArrowLeftOutlined, PlusCircleOutlined } from '@ant-design/icons';
import CorporateTraderService from '../../services/CorporateTraderService';
import ModalForm from '../../components/ModalForm/ModalForm';
import generateUploadUrlService from '../../services/GenerateUploadUrlService';
import { getFileIconByURL } from '../../util/Common';
import WorkflowAccOpeningService from '../../services/WorkflowAccOpeningService';
import WorkflowAccModificationService from '../../services/WorkflowAccModificationService';
import dayjs from 'dayjs';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Text, Title } = Typography;

export default function FillCorporateTrader({ type }) {
  // React hooks
  const { traderId } = useParams();
  const navigate = useNavigate();
  const [traderInformation, setTraderInformation] = useState(null);
  const { showNotification, user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [clickedRecord, setClickedRecord] = useState({});
  const [open, setOpen] = useState(false);
  const [activePanels, setActivePanels] = useState(['1']);
  const [isSaved, setIsSaved] = useState(true);

  const handleFinishFailed = ({ errorFields }) => {
    console.log(errorFields);
    if (errorFields.length > 0) {
      const firstErrorField = errorFields[0].name[0];
      const errorPanel = fieldToPanelMappingForCorporateTrader[firstErrorField];
      console.log(errorPanel);
      setActivePanels([errorPanel]);
    }
  };
  // Form control dependency from ant design
  const [form] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState('');
  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
    setIsSaved(false);
  };

  const WorkflowService =
    type === 'modification' ? WorkflowAccModificationService : WorkflowAccOpeningService;

  // Get corporate trader with id
  const fetchData = async () => {
    try {
      let result;
      setLoading(true);
      result = await WorkflowService.getCorporateAcc({ workflowId: traderId });
      setLoading(false);
      console.log(result.data);
      if (result.success) {
        result.data.directorDataList = result.data.directorDataList.map((item, i) => ({
          key: i.toString(),
          ...item,
        }));
        console.log(result);
        result.data.corporateAccountOpeningData =
          type === 'modification'
            ? result.data.corporateAccountModificationData
            : result.data.corporateAccountOpeningData;

        result.data.corporateAccountOpeningData.stage =
          type === 'modification'
            ? result.data.corporateAccountModificationData.workflowStage
            : result.data.corporateAccountOpeningData.stage;
        result.data.authorizedPersonDataList = result.data.authorizedPersonDataList.map(
          (item, i) => ({
            key: i.toString(),
            ...item,
          }),
        );
        result.data.companyDataList = result.data.companyDataList.map((item, i) => ({
          key: i.toString(),
          ...item,
        }));
        setTraderInformation(result.data);
        renderData(result.data);
        console.log(result.data);
      } else {
        showNotification('error', result.message);
      }
    } catch (error) {
      showNotification('error', error.message);
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  // console.log(traderInformation);

  // Show existing data into form items
  const renderData = data => {
    console.log(data);

    form.setFieldsValue({
      primaryEmail: data.corporateAccountOpeningData.primaryEmail,
      ccEmail: data.ccEmail,
      bccEmail: data.bccEmail,
      traderClientType: data.applicationInfo.clientType,
      traderIdentityType: data.corporateProfile.identityType,
      traderIdNumber: data.corporateProfile.identityValue,
      traderNameOnID: data.corporateProfile.nameOnIdentity,
      traderFirmName: data.corporateProfile.firmName,
      traderRegistrationNo: data.corporateProfile.registrationNo,
      traderDateOfIncorporation: data.corporateProfile.dateOfIncorporation
        ? dayjs.unix(data.corporateProfile.dateOfIncorporation)
        : null,
      traderSourceOfFund: data.corporateProfile.sourceOfFund,
      traderNetWorth: data.corporateProfile.netWorth,
      traderNetWorthOnDate: data.corporateProfile.netWorthOnDate
        ? dayjs.unix(data.corporateProfile.netWorthOnDate)
        : null,
      traderLatestFinancialYearDate: data.corporateProfile.latestFinancialYearDatedAs
        ? dayjs.unix(data.corporateProfile.latestFinancialYearDatedAs)
        : null,
      traderBoardOfResolutionDate: data.corporateProfile.boardOfResolutionDatedAs
        ? dayjs.unix(data.corporateProfile.boardOfResolutionDatedAs)
        : null,
      traderTypeOfInstitution: data.corporateProfile.typeOfInstitution,
      traderTypeOfFacility: data.corporateProfile.typeOfFacility,
      traderPaidUpCapital: data.corporateProfile.paidUpCapital,
      traderDescription: data.corporateProfile.description,
      traderInPersonVerification: data.corporateProfile.inPersonVerification,
      tradingAccountType: data.tradingBankAccount.accountType,
      tradingAccountNumber: data.tradingBankAccount.accountNo,
      tradingSwiftCode: data.tradingBankAccount.bankSwiftCode,
      tradingBankCode: data.tradingBankAccount.bankCode,
      tradingBankName: data.tradingBankAccount.bankName,
      tradingBranchCode: data.tradingBankAccount.bankBranchCode,
      tradingBranchName: data.tradingBankAccount.bankBranchName,
      tradingAddress: data.tradingBankAccount.address,
      tradingTownship: data.tradingBankAccount.township,
      tradingCity: data.tradingBankAccount.city,
      tradingState: data.tradingBankAccount.state,
      tradingCountry: data.tradingBankAccount.country,
      tradingPostalCode: data.tradingBankAccount.postalCode,
      tradingPOA: data.tradingBankAccount.poa,
      tradingPhoneNumber: data.tradingBankAccount.phoneNo,
      tradingPoaAgreementDate: data.tradingBankAccount.poaAgreementDate
        ? dayjs.unix(data.tradingBankAccount.poaAgreementDate)
        : null,
      corporateAccountType: data.corporateBankAccount.accountType,
      corporateAccountNumber: data.corporateBankAccount.accountNo,
      corporateSwiftCode: data.corporateBankAccount.bankSwiftCode,
      corporateBankCode: data.corporateBankAccount.bankCode,
      corporateBankName: data.corporateBankAccount.bankName,
      corporateBranchCode: data.corporateBankAccount.bankBranchCode,
      corporateBranchName: data.corporateBankAccount.bankBranchName,
      corporateAddress: data.corporateBankAccount.address,
      corporatePostalCode: data.corporateBankAccount.postalCode,
      corporateTownship: data.corporateBankAccount.township,
      corporateCity: data.corporateBankAccount.city,
      corporateState: data.corporateBankAccount.state,
      corporateCountry: data.corporateBankAccount.country,
      corporatePhoneNumber: data.corporateBankAccount.phoneNo,
      corporatePOA: data.corporateBankAccount.poa,
      corporatePoaAgreementDate: data.corporateBankAccount.poaAgreementDate
        ? dayjs.unix(data.corporateBankAccount.poaAgreementDate)
        : null,
      applicationForm: data.corporateProofDocument.applicationFormKey,
      companyRegistrationCertificate: data.corporateProofDocument.companyRegistrationCertificateKey,
      authorizedPersonIdentity: data.corporateProofDocument.authorizedPersonIdentity,
      bodResolution: data.corporateProofDocument.bodResolutionKey,
      personalBankAccount: data.corporateProofDocument.personalBankAccountKey,
      companyConstitution: data.corporateProofDocument.companyConstitutionKey,
      // No need to add Director Data List
      // No need to add Authorized Person Data List
      // No need to add Company Data List
    });
  };

  // Form Save
  const handleSave = async () => {
    // console.log(formValues);

    const ccEmail = form.getFieldValue('ccEmail');
    const bccEmail = form.getFieldValue('bccEmail');
    const primaryEmail = form.getFieldValue('primaryEmail');

    const payload = {
      ccEmail: ccEmail,
      bccEmail: bccEmail,
      primaryEmail: primaryEmail,
      workflowId: traderId,
      corporateProfile: {
        // identityType: form.getFieldValue('traderIdentityType') || null,
        // identityValue: form.getFieldValue('traderIdNumber') || null,
        // nameOnIdentity: form.getFieldValue('traderNameOnID') || null,
        firmName: form.getFieldValue('traderFirmName') || null,
        registrationNo: form.getFieldValue('traderRegistrationNo') || null,
        dateofIncorporation: form.getFieldValue('traderDateOfIncorporation') || null,
        sourceOfFund: form.getFieldValue('traderSourceOfFund') || null,
        netWorth: form.getFieldValue('traderNetWorth') || null,
        netWorthOnDate: form.getFieldValue('traderNetWorthOnDate') || null,
        latestFinancialYearDatedAs: form.getFieldValue('traderLatestFinancialYearDate') || null,
        boardOfResolutionDatedAs: form.getFieldValue('traderBoardOfResolutionDate') || null,
        inPersonVerification: form.getFieldValue('traderInPersonVerification'),
        typeOfInstitution: form.getFieldValue('traderTypeOfInstitution') || null,
        typeOfFacility: form.getFieldValue('traderTypeOfFacility') || null,
        paidUpCapital: form.getFieldValue('traderPaidUpCapital') || null,
        description: form.getFieldValue('traderDescription') || null,
      },
      tradingBankAccount: {
        accountNo: form.getFieldValue('tradingAccountNumber') || null,
        accountType: form.getFieldValue('tradingAccountType') || null,
        address: form.getFieldValue('tradingAddress') || null,
        bankBranchCode: form.getFieldValue('tradingBranchCode') || null,
        bankBranchName: form.getFieldValue('tradingBranchName') || null,
        bankCode: form.getFieldValue('tradingBankCode') || null,
        bankName: form.getFieldValue('tradingBankName') || null,
        bankSwiftCode: form.getFieldValue('tradingSwiftCode') || null,
        city: form.getFieldValue('tradingCity') || null,
        country: form.getFieldValue('tradingCountry') || null,
        phoneNo: form.getFieldValue('tradingPhoneNumber') || null,
        poa: form.getFieldValue('tradingPOA') || false,
        poaAgreementDate: form.getFieldValue('tradingPoaAgreementDate') || null,
        postalCode: form.getFieldValue('tradingPostalCode') || null,
        state: form.getFieldValue('tradingState') || null,
        township: form.getFieldValue('tradingTownship') || null,
      },
      corporateBankAccount: {
        accountNo: form.getFieldValue('corporateAccountNumber') || null,
        accountType: form.getFieldValue('corporateAccountType') || null,
        address: form.getFieldValue('corporateAddress') || null,
        bankBranchCode: form.getFieldValue('corporateBranchCode') || null,
        bankBranchName: form.getFieldValue('corporateBranchName') || null,
        bankCode: form.getFieldValue('corporateBankCode') || null,
        bankName: form.getFieldValue('corporateBankName') || null,
        bankSwiftCode: form.getFieldValue('corporateSwiftCode') || null,
        city: form.getFieldValue('corporateCity') || null,
        country: form.getFieldValue('corporateCountry') || null,
        phoneNo: form.getFieldValue('corporatePhoneNumber') || null,
        poa: form.getFieldValue('corporatePOA') || false,
        poaAgreementDate: form.getFieldValue('corporatePoaAgreementDate') || null,
        postalCode: form.getFieldValue('corporatePostalCode') || null,
        state: form.getFieldValue('corporateState') || null,
        township: form.getFieldValue('corporateTownship') || null,
      },
      corporateProofDocument: {
        applicationFormKey: form.getFieldValue('applicationFormKey') || null,
        authorizedPersonIdentityKey: form.getFieldValue('authorizedPersonIdentityKey') || null,
        bodResolutionKey: form.getFieldValue('bodResolutionKey') || null,
        companyConstitutionKey: form.getFieldValue('companyConstitutionKey') || null,
        companyRegistrationCertificateKey:
          form.getFieldValue('companyRegistrationCertificateKey') || null,
        personalBankAccountKey: form.getFieldValue('personalBankAccountKey') || null,
      },
    };
    setLoading(true);
    console.log(payload);
    const result = await WorkflowService.saveCorporateAcc(payload);
    if (result.success) {
      showNotification('success', 'Saved');
      setIsSaved(true);
    } else {
      showNotification('error', result.message);
    }
    setLoading(false);
  };

  // Form submit
  const handleSubmit = async traderId => {
    setLoading(true);
    const result = await WorkflowService.submitCorporateAcc({ workflowId: traderId });

    if (result.success) {
      showNotification('success', 'Submitted');
      navigate(type === 'modification' ? '/modification' : '/');
    } else {
      showNotification('error', result.message);
    }
    setLoading(false);
    handleClose();
  };

  // Approve trader
  const handleApprove = async traderId => {
    console.log({ traderId });
    setLoading(true);
    const result = await WorkflowService.approveCorporateAcc({
      workflowId: traderId,
      // checkerId: user.userId,
    });
    if (result.success) {
      showNotification('success', 'Approved');
      navigate('/corporate');
    } else {
      showNotification('error', result.message);
    }
    setLoading(false);
    handleClose();
  };

  const handleDeleteAcc = async traderId => {
    setLoading(true);
    const result = await WorkflowService.deleteAcc({ workflowId: traderId });
    if (result.success) {
      showNotification('success', 'Deleted');
      navigate(`/${type === 'modification' ? type : ''}`);
    } else {
      showNotification('error', result.message);
    }
    setLoading(false);
    handleCancel();
  };

  const handleUpload = async (options, documentType) => {
    const { file, onSuccess, onError, onProgress } = options;

    const filetype = file.type;
    const fileInfoArr = file.name.split('.');
    const extension = fileInfoArr[fileInfoArr.length - 1];

    console.log({ extension, filetype, documentType });
    try {
      // 1. Get the presigned URL from API - upload-xxx-document
      const response = await WorkflowService.generateCorporateDocument({
        extension: extension,
        workflowId: traderId,
        corporateDocumentType: documentType,
      });

      console.log(response);

      if (!response.success) {
        showNotification('error', response.message);
        return;
      }

      // 2. Upload the file to S3
      try {
        const resp = await axios.put(response.uploadUrl, file, {
          onUploadProgress: progressEvent => {
            const { loaded, total } = progressEvent;
            const percent = Math.round((loaded / total) * 100);
            onProgress({ percent });
          },
          headers: {
            'Content-Type': filetype,
          },
        });

        onSuccess(resp.data, file);
        // showNotification('success', 'File uploaded successfully');
      } catch (error) {
        onError(error);
        console.log(error);
        showNotification('error', 'File upload failed');
      }
    } catch (error) {
      showNotification('error', error.message);
    }
  };

  // Director, Authorized Person and Company Owner related
  const [openDirModal, setOpenDirModal] = useState(false);
  const [openAuthModal, setAuthModal] = useState(false);
  const [openCompanyModal, setCompanyModal] = useState(false);
  const [editingRow, setEditingRow] = useState(null);

  const handleDelete = async (id, role) => {
    let result;
    setLoading(true);
    if (role === 'director') {
      const payload = {
        workflowId: traderId,
        directorId: id,
        traderDirectorId: id,
      };
      if (type === 'modification') {
        delete payload['directorId'];
      } else {
        delete payload['traderDirectorId'];
      }

      result = await WorkflowService.removeCorporateDirector(payload);
    } else if (role === 'authorized person') {
      const payload = {
        workflowId: traderId,
        authorizedPersonId: id,
        traderAuthorizedPersonId: id,
      };

      if (type === 'modification') {
        delete payload['authorizedPersonId'];
      } else {
        delete payload['traderAuthorizedPersonId'];
      }
      result = await WorkflowService.removeCorporateAuthPerson(payload);
    } else if (role === 'company owner') {
      const payload = {
        workflowId: traderId,
        companyId: id,
        traderCompanyId: id,
      };

      if (type === 'modification') {
        delete payload['companyId'];
      } else {
        delete payload['traderCompanyId'];
      }
      result = await WorkflowService.removeCorporateCompanyOwner(payload);
    }

    setLoading(false);
    if (result.success) {
      showNotification('success', 'Delete successful');
      fetchData();
      setClickedRecord({});
      setOpen(false);
    } else {
      showNotification('error', result.message);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setClickedRecord({});
  };

  // const showPopconfirm = id => {
  //   setClickedId(id);
  // };
  // Director Table
  const directorTable = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        if (editingRow === record.directorId) {
          return (
            <Input defaultValue={record.name} onChange={e => (record.name = e.target.value)} />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'NRC',
      dataIndex: 'nrcNo',
      key: 'nrcNo',
      render: (text, record) => {
        if (editingRow === record.directorId) {
          return (
            <Input defaultValue={record.nrcNo} onChange={e => (record.nrcNo = e.target.value)} />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'Resident Address',
      dataIndex: 'residentialAddress',
      key: 'residentialAddress',
      render: (text, record) => {
        if (editingRow === record.directorId) {
          return (
            <Input
              defaultValue={record.residentialAddress}
              onChange={e => (record.residentialAddress = e.target.value)}
            />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          {editingRow === record.directorId ? (
            <Button type={'primary'} onClick={() => modifyDirector(record)}>
              Save
            </Button>
          ) : (
            <>
              <Button
                icon={
                  <Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />
                }
                type={'link'}
                onClick={() => {
                  setEditingRow(record.directorId);
                }}
              ></Button>
              {/* <Popconfirm
                title={record.name}
                description="Are you sure to delete this director?"
                open={clickedId === record.directorId}
                onConfirm={() => handleDelete(record.directorId, 'director')}
                okButtonProps={{ loading: loading }}
                onCancel={handleCancel}
              > */}
              <Button
                type={'link'}
                icon={
                  <Image src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} preview={false} />
                }
                onClick={() => {
                  setClickedRecord({
                    clickedId:
                      type === 'modification' ? record.traderDirectorId : record.directorId,
                    title: record.name,
                    role: 'director',
                  });
                  setOpen(true);
                }}
              />
              {/* </Popconfirm> */}
            </>
          )}
        </>
      ),
    },
  ];

  // Authorized Person Table
  const authPersonTable = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        if (editingRow === record.authorizedPersonId) {
          return (
            <Input defaultValue={record.name} onChange={e => (record.name = e.target.value)} />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'NRC',
      dataIndex: 'nrcNo',
      key: 'nrcNo',
      render: (text, record) => {
        if (editingRow === record.authorizedPersonId) {
          return (
            <Input defaultValue={record.nrcNo} onChange={e => (record.nrcNo = e.target.value)} />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
      render: (text, record) => {
        if (editingRow === record.authorizedPersonId) {
          return (
            <Input
              defaultValue={record.designation}
              onChange={e => (record.designation = e.target.value)}
            />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'Signature',
      dataIndex: 'signature',
      key: 'signature',
      render: (signature, record) => {
        if (editingRow === record.authorizedPersonId) {
          return (
            <Switch
              defaultChecked={signature}
              checkedChildren="Yes"
              unCheckedChildren="No"
              onChange={checked => (record.signature = checked)}
            />
          );
        } else {
          return <Text>{signature ? 'Yes' : 'No'}</Text>;
        }
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          {editingRow === record.authorizedPersonId ? (
            <Button type={'primary'} onClick={() => modifyAuthPerson(record)}>
              Save
            </Button>
          ) : (
            <>
              <Button
                icon={
                  <Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />
                }
                type={'link'}
                onClick={() => {
                  setEditingRow(record.authorizedPersonId);
                }}
              ></Button>
              {/* <Popconfirm
                title={record.name}
                description="Are you sure to delete this authorized?"
                open={clickedId === record.authorizedPersonId}
                onConfirm={() => handleDelete(record.authorizedPersonId, 'authorized')}
                okButtonProps={{ loading: loading }}
                onCancel={handleCancel}
              > */}
              <Button
                type={'link'}
                icon={
                  <Image src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} preview={false} />
                }
                onClick={() => {
                  setClickedRecord({
                    clickedId:
                      type === 'modification'
                        ? record.traderAuthorizedPersonId
                        : record.authorizedPersonId,
                    title: record.name,
                    role: 'authorized person',
                  });
                  setOpen(true);
                }}
              />
              {/* </Popconfirm> */}
            </>
          )}
        </>
      ),
    },
  ];

  // Company Owner Table
  const companyOwnerTable = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        if (editingRow === record.companyId) {
          return (
            <Input defaultValue={record.name} onChange={e => (record.name = e.target.value)} />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'NRC',
      dataIndex: 'nrcNo',
      key: 'nrcNo',
      render: (text, record) => {
        if (editingRow === record.companyId) {
          return (
            <Input
              defaultValue={record.nrcNo}
              onChange={e => {
                console.log(e.target.value);
                record.nrcNo = e.target.value;
              }}
            />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: '% of Share Holders',
      dataIndex: 'percentOfShareholders',
      key: 'percentOfShareholders',
      render: (text, record) => {
        if (editingRow === record.companyId) {
          return (
            <InputNumber
              defaultValue={record.percentOfShareholders}
              onChange={e => (record.percentOfShareholders = e)}
            />
          );
        } else {
          return <Text>{text}</Text>;
        }
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          {editingRow === record.companyId ? (
            <Button type={'primary'} onClick={() => modifyCompanyOwner(record)}>
              Save
            </Button>
          ) : (
            <>
              <Button
                icon={
                  <Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />
                }
                type={'link'}
                onClick={() => {
                  setEditingRow(record.companyId);
                }}
              ></Button>
              {/* <Popconfirm
                title={record.name}
                description="Are you sure to delete this company owner?"
                open={clickedId === record.companyId}
                onConfirm={() => handleDelete(record.companyId, 'company owner')}
                okButtonProps={{ loading: loading }}
                onCancel={handleCancel}
              > */}
              <Button
                type={'link'}
                icon={
                  <Image src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} preview={false} />
                }
                onClick={() => {
                  setClickedRecord({
                    clickedId: type === 'modification' ? record.traderCompanyId : record.companyId,
                    title: record.name,
                    role: 'company owner',
                  });
                  setOpen(true);
                }}
              />
              {/* </Popconfirm> */}
            </>
          )}
        </>
      ),
    },
  ];

  const toggleDirModal = () => {
    setOpenDirModal(!openDirModal);
  };

  const toggleAuthModal = () => {
    setAuthModal(!openAuthModal);
  };

  const toggleCompanyModal = () => {
    setCompanyModal(!openCompanyModal);
  };

  // Add director
  const addDirector = async e => {
    const payload = {
      workflowId: traderId,
      name: e.name,
      nrcNo: e.nrcNo,
      residentialAddress: e.residentialAddress,
    };

    console.log(payload);
    const result = await WorkflowService.addCorporateDirector(payload);

    if (result.success) {
      showNotification('success', 'Successfully submitted');
      fetchData();
    } else {
      showNotification('error', result.message);
    }

    toggleDirModal();
  };

  // Edit director
  const modifyDirector = async record => {
    const payload = {
      workflowId: traderId,
      existingDirectorId: record.directorId,
      traderDirectorId: record.traderDirectorId,
      newName: record.name,
      newNrcNo: record.nrcNo,
      newResidentialAddress: record.residentialAddress,
    };
    if (type === 'modification') {
      delete payload['existingDirectorId'];
    } else {
      delete payload['traderDirectorId'];
    }
    console.log(payload);
    const result = await WorkflowService.modifyCorporateDirector(payload);
    if (result.success) {
      showNotification('success', 'Edit successful');
      fetchData();
      setEditingRow(null);
    } else {
      showNotification('error', result.message);
    }
  };

  // Add authorizedPerson
  const addAuthPerson = async e => {
    const payload = {
      workflowId: traderId,
      name: e.name,
      nrcNo: e.nrcNo,
      designation: e.designation,
      signature: e.signature,
    };

    console.log(payload);
    const result = await WorkflowService.addCorporateAuthorizedPerson(payload);

    if (result.success) {
      showNotification('success', 'Successfully submitted');
      fetchData();
    } else {
      showNotification('error', result.message);
    }

    toggleAuthModal();
  };

  // Edit authorized person
  const modifyAuthPerson = async record => {
    const payload = {
      workflowId: traderId,
      existingAuthorizedPersonId: record.authorizedPersonId,
      traderAuthorizedPersonId: record.traderAuthorizedPersonId,
      newName: record.name,
      newNrcNo: record.nrcNo,
      newDesignation: record.designation,
      newSignature: record.signature,
    };

    if (type === 'modification') {
      delete payload['existingAuthorizedPersonId'];
    } else {
      delete payload['traderAuthorizedPersonId'];
    }
    console.log(payload);
    const result = await WorkflowService.modifyCorporateAuthorizedPerson(payload);
    if (result.success) {
      showNotification('success', 'Edit successful');
      fetchData();
      setEditingRow(null);
    } else {
      showNotification('error', result.message);
    }
  };

  // Add companyOwner
  const addCompanyOwner = async e => {
    const payload = {
      workflowId: traderId,
      name: e.name,
      nrcNo: e.nrcNo,
      percentOfShareholders: e.percentOfShareholders,
    };

    console.log(payload);
    const result = await WorkflowService.addCorporateCompanyOwner(payload);

    if (result.success) {
      showNotification('success', 'Successfully submitted');
      fetchData();
    } else {
      showNotification('error', result.message);
    }

    toggleCompanyModal();
  };

  // Edit company
  const modifyCompanyOwner = async record => {
    const payload = {
      workflowId: traderId,
      ExistingCompanyId: record.companyId,
      traderCompanyId: record.traderCompanyId,
      newName: record.name,
      newNrcNo: record.nrcNo,
      newPercentOfShareholders: record.percentOfShareholders,
    };
    if (type === 'modification') {
      delete payload['ExistingCompanyId'];
    } else {
      delete payload['traderCompanyId'];
    }
    console.log(payload);
    const result = await WorkflowService.modifyCorporateCompanyOwner(payload);
    if (result.success) {
      showNotification('success', 'Edit successful');
      fetchData();
      setEditingRow(null);
    } else {
      showNotification('error', result.message);
    }
  };

  // Input options
  const clientType = ['LOCAL_CORPORATE', 'FOREIGN_CORPORATE'];
  const netWorthOptions = [
    'Below & Equal to MMK 10,000,000',
    'From MMK 10,000,001 to MMK 50,000,000',
    'From MMK 50,000,001 to MMK 100,000,000',
    'Above MMK 100,000,000',
  ];
  const sourceOfFundOptions = ['EMPLOYMENT', 'SELF_EMPLOYED', 'INHERITANCE', 'OTHERS'];

  const goBack = () => {
    navigate(-1); // Go back one page in history
  };

  const handleModal = async type => {
    switch (type) {
      case 'submit':
        if (!isSaved) {
          showNotification('error', 'Please save the changes values before submit.');
          return;
        }
        await handleSubmit(traderId);
        break;
      case 'approve':
        await handleApprove(traderId);
        break;
      case 'delete':
        await handleDeleteAcc(traderId);
        break;
      default:
        break;
    }
  };

  const [clickType, setClickType] = useState('');

  const handleClose = () => {
    setClickType('');
  };

  return (
    <>
      {/* {open && ( */}
      <Modal
        title={traderInformation?.corporateAccountOpeningData.tradingAccountNo}
        open={clickType.length === 0 ? false : true}
        onOk={() => handleModal(clickType)}
        confirmLoading={loading}
        onCancel={handleClose}
      >
        <p>{'Are you sure to ' + clickType + ' this account'}</p>
      </Modal>
      <Modal
        title={clickedRecord.title}
        open={open}
        onOk={() => handleDelete(clickedRecord.clickedId, clickedRecord.role)}
        onCancel={handleCancel}
        okText="OK"
        cancelText="Cancel"
        confirmLoading={loading}
      >
        Are you sure to delete this {clickedRecord.role}?
      </Modal>
      {/* )} */}
      <Title level={4} style={{ marginTop: 0, marginBottom: '2rem', textTransform: 'capitalize' }}>
        Corporate Account {type} - Submission
      </Title>

      <Card title="Step 2 of 2: Filling" style={{ background: '#fcfcfc' }}>
        <Space direction="vertical" size={'middle'} style={{ width: '100%' }}>
          {/* {traderInformation !== null ? ( */}
          <Descriptions
            title={<Text>Trader Information</Text>}
            size={'middle'}
            column={{ xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}
          >
            <Descriptions.Item label="Application No">
              <Text strong>{traderInformation?.applicationInfo.applicationNo}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Exchange">
              <Text strong>{traderInformation?.corporateAccountOpeningData.exchangeSegment}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Agreement Date">
              <Text strong>
                {dayjs
                  .unix(traderInformation?.applicationInfo.agreementDate)
                  .format('DD-MMMM-YYYY')}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="Firm Name">
              <Text strong>{traderInformation?.corporateProfile.firmName}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Source of fund">
              <Text strong>{traderInformation?.corporateProfile.sourceOfFund}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Net Worth">
              <Text strong>{traderInformation?.corporateProfile.netWorth}</Text>
            </Descriptions.Item>
          </Descriptions>
          {/* ) : null} */}
          <Divider />
          <Form
            onFinish={() => {
              setClickType('submit');
            }}
            onFinishFailed={handleFinishFailed}
            form={form}
            labelCol={{
              span: 8,
              lg: {
                span: 12,
              },
              // xl: {
              //   span: 12,
              // },
            }}
            labelWrap={true}
            layout="horizontal"
            size={'medium'}
            // required field related
            initialValues={{
              requiredMarkValue: requiredMark,
              // tradingAccountType: 'CURRENT_ACCOUNT',
              // personalAccountType: 'SAVING_ACCOUNT',
            }}
            onValuesChange={onRequiredTypeChange}
            requiredMark={requiredMark}
          >
            <Collapse
              defaultActiveKey={['1']}
              bordered={false}
              expandIconPosition={'end'}
              accordion
              activeKey={activePanels}
              onChange={setActivePanels}
            >
              {/* Emails */}
              <Panel header={'Email'} key={'1'} forceRender>
                <Row gutter={16} style={{ marginTop: '2rem' }}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      label="Primary Email"
                      name={'primaryEmail'}
                      rules={[
                        {
                          type: 'email',
                          message: 'The input is not valid E-mail!',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="CC Email"
                      name={'ccEmail'}
                      rules={[
                        {
                          type: 'email',
                          message: 'The input is not valid E-mail!',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      label="BCC Email"
                      name={'bccEmail'}
                      rules={[
                        {
                          type: 'email',
                          message: 'The input is not valid E-mail!',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              {/* Trader Profile */}
              <Panel header={'Trader Profile'} key={'2'} forceRender>
                <Row gutter={16} style={{ marginTop: '2rem' }}>
                  <Col
                    xs={{
                      span: 24,
                      // order: 2,
                    }}
                    sm={24}
                    md={24}
                    lg={{
                      span: 12,
                      // order: 1,
                    }}
                  >
                    <Form.Item
                      label="Firm Name"
                      name={'traderFirmName'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Registration No"
                      name={'traderRegistrationNo'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    {/* <Form.Item label="Client Type" name={'traderClientType'}>
                      <Select
                        options={clientType.map(item => ({
                          label: item,
                          value: item,
                        }))}
                      />
                    </Form.Item> */}

                    <Form.Item
                      label="Date of Incorporation"
                      name={'traderDateOfIncorporation'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <DatePicker
                        style={{
                          width: '100%',
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Source Of Fund"
                      name={'traderSourceOfFund'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Select
                        options={sourceOfFundOptions.map(item => ({
                          labe: item,
                          value: item,
                        }))}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Net Worth"
                      name={'traderNetWorth'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Select
                        options={netWorthOptions.map(item => ({
                          label: item,
                          value: item,
                        }))}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Net Worth on Date"
                      name={'traderNetWorthOnDate'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <DatePicker
                        style={{
                          width: '100%',
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{
                      span: 24,
                      // order: 1,
                    }}
                    sm={24}
                    md={24}
                    lg={{
                      span: 12,
                      // order: 2,
                    }}
                  >
                    <Form.Item
                      label="Latest Financial Year Date"
                      name={'traderLatestFinancialYearDate'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <DatePicker
                        style={{
                          width: '100%',
                        }}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Board Of Resolution Date"
                      name={'traderBoardOfResolutionDate'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <DatePicker
                        style={{
                          width: '100%',
                        }}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Type Of Institution"
                      name={'traderTypeOfInstitution'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Type Of Facility"
                      name={'traderTypeOfFacility'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Paid Up Capital"
                      name={'traderPaidUpCapital'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Input style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                      label="Description"
                      name={'traderDescription'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Status (In Person Verification)"
                      name="traderInPersonVerification"
                      valuePropName="checked"
                      // initialValue={false}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              {/* Trading Bank Account */}
              <Panel header={'Trading Bank Account'} key={'3'} forceRender>
                <Row gutter={[16, 16]} style={{ marginTop: '2rem' }}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      label="Account Type"
                      name={'tradingAccountType'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Select>
                        <Select.Option value="SAVING_ACCOUNT">SAVING_ACCOUNT</Select.Option>
                        <Select.Option value="CURRENT_ACCOUNT">CURRENT_ACCOUNT</Select.Option>
                        <Select.Option value="CASH_CURRENT_ACCOUNT">
                          CASH_CURRENT_ACCOUNT
                        </Select.Option>
                        <Select.Option value="TRADING_BANK_ACCOUNT">
                          TRADING_BANK_ACCOUNT
                        </Select.Option>
                        <Select.Option value="OTHERS">OTHERS</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Account Number"
                      name={'tradingAccountNumber'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Swift Code"
                      name={'tradingSwiftCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Bank Code"
                      name={'tradingBankCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Bank Name"
                      name={'tradingBankName'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Branch Code"
                      name={'tradingBranchCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Branch Name"
                      name={'tradingBranchName'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Address"
                      name={'tradingAddress'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <TextArea rows={8} onChange={e => e.target.value} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      label="Township"
                      name={'tradingTownship'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="City"
                      name={'tradingCity'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="State"
                      name={'tradingState'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Country"
                      name={'tradingCountry'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Postal Code"
                      name={'tradingPostalCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="POA"
                      name="tradingPOA"
                      valuePropName="checked"
                      // initialValue={false}
                    >
                      <Checkbox defaultChecked={false}></Checkbox>
                    </Form.Item>

                    <Form.Item
                      label="Phone No"
                      name={'tradingPhoneNumber'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="POA Agreement Date"
                      name={'tradingPoaAgreementDate'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <DatePicker
                        style={{
                          width: '100%',
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              {/* Corporate Bank Account */}
              <Panel header={'Corporate Bank Account'} key={'4'} forceRender>
                <Row gutter={[16, 16]} style={{ marginTop: '1rem' }}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      label="Account Type"
                      name={'corporateAccountType'}
                      rules={[
                        {
                          required: true,
                          message: 'Please do not leave blank',
                        },
                      ]}
                    >
                      <Select>
                        <Select.Option value="SAVING_ACCOUNT">SAVING_ACCOUNT</Select.Option>
                        <Select.Option value="CURRENT_ACCOUNT">CURRENT_ACCOUNT</Select.Option>
                        <Select.Option value="CASH_CURRENT_ACCOUNT">
                          CASH_CURRENT_ACCOUNT
                        </Select.Option>
                        <Select.Option value="TRADING_BANK_ACCOUNT">
                          TRADING_BANK_ACCOUNT
                        </Select.Option>
                        <Select.Option value="OTHERS">OTHERS</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Account Number"
                      name={'corporateAccountNumber'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Swift Code"
                      name={'corporateSwiftCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Bank Code"
                      name={'corporateBankCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Bank Name"
                      name={'corporateBankName'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Branch Code"
                      name={'corporateBranchCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Branch Name"
                      name={'corporateBranchName'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Address"
                      name={'corporateAddress'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <TextArea rows={8} onChange={e => e.target.value} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      label="Township"
                      name={'corporateTownship'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="City"
                      name={'corporateCity'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="State"
                      name={'corporateState'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Country"
                      name={'corporateCountry'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Postal Code"
                      name={'corporatePostalCode'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="POA"
                      name="corporatePOA"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Checkbox></Checkbox>
                    </Form.Item>
                    <Form.Item
                      label="Phone No"
                      name={'corporatePhoneNumber'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="POA Agreement Date"
                      name={'corporatePoaAgreementDate'}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Please do not leave blank',
                      //   },
                      // ]}
                    >
                      <DatePicker
                        style={{
                          width: '100%',
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              {/* Proof Documents */}
              <Panel header={'Proof Documents'} key={'5'} forceRender>
                <Row gutter={[16, 16]} style={{ marginTop: '2rem' }}>
                  {uploadFields.map(uploadField => {
                    return (
                      <Col xs={24} sm={24} md={24} lg={12} key={uploadField.name}>
                        <Form.Item
                          label={
                            <span>
                              {uploadField.require && type !== 'modification' && (
                                <span
                                  style={{
                                    display: 'inline-block',
                                    color: '#ff4d4f',
                                    fontFamily: '"SimSun, sans-serif"',
                                    transform: 'translateY(4px)',
                                    fontSize: '18px',
                                    lineHeight: '1',
                                    marginInlineEnd: '4px',
                                  }}
                                >
                                  *
                                </span>
                              )}
                              {uploadField.label}
                            </span>
                          }
                          name={uploadField.name}
                          valuePropName={'file'}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  traderInformation?.corporateProofDocument[uploadField.name] !==
                                    '' ||
                                  !uploadField.require ||
                                  type === 'modification'
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error(uploadField.message));
                              },
                            }),
                          ]}
                        >
                          {traderInformation &&
                          traderInformation.corporateProofDocument &&
                          traderInformation.corporateProofDocument[uploadField.name] ? (
                            <a
                              href={traderInformation.corporateProofDocument[uploadField.name]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {getFileIconByURL(
                                traderInformation.corporateProofDocument[uploadField.name],
                              )}{' '}
                              {uploadField.label}
                            </a>
                          ) : // <img src={traderInformation.corporateProofDocument[uploadField.name]} alt="Preview" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                          null}
                          <Upload.Dragger
                            multiple={false}
                            maxCount={1}
                            disabled={
                              traderInformation?.corporateAccountOpeningData.stage === 'PREPARING'
                                ? false
                                : true
                            }
                            onChange={async info => {
                              if (info.file.status === 'done') {
                                showNotification(
                                  'success',
                                  `${info.file.name} file uploaded successfully`,
                                );
                                fetchData();
                                await fetchData();
                                form.validateFields([uploadField.name]);
                              } else if (info.file.status === 'error') {
                                showNotification('error', `${info.file.name} file upload failed.`);
                              }
                            }}
                            customRequest={async options =>
                              handleUpload(options, uploadField.documentType)
                            }
                          >
                            <Text>
                              Drag and drop here <br /> - Or - <br />
                              <Button icon={<UploadOutlined />}>Upload</Button>
                            </Text>
                          </Upload.Dragger>
                        </Form.Item>
                      </Col>
                    );
                  })}
                </Row>
              </Panel>

              {/* Director List */}
              <Panel header={'Director'} key={'6'} forceRender>
                <ModalForm
                  title={'Add Director'}
                  formItems={directorFormFields}
                  open={openDirModal}
                  toggleModal={toggleDirModal}
                  apiCall={addDirector}
                />
                <Table
                  columns={
                    traderInformation?.corporateAccountOpeningData.stage === 'PREPARING'
                      ? directorTable
                      : directorTable.filter(item => item.key !== 'action')
                  }
                  dataSource={traderInformation !== null ? traderInformation.directorDataList : []}
                  size={'large'}
                  bordered
                  style={{ shaodw: '0 0 5px solid black', marginBottom: '1rem' }}
                  scroll={{
                    x: 'max-content',
                  }}
                  rowClassName={record => record.modificationType}
                />
                {traderInformation?.corporateAccountOpeningData.stage === 'PREPARING' && (
                  <div style={{ textAlign: 'right' }}>
                    <Button type={'dashed'} icon={<PlusCircleOutlined />} onClick={toggleDirModal}>
                      Add
                    </Button>
                  </div>
                )}
              </Panel>

              {/* Authorized Person List */}
              <Panel header={'Authorized Person'} key={'7'} forceRender>
                <ModalForm
                  title={'Add Authorized Person'}
                  formItems={authPersonFormFields}
                  open={openAuthModal}
                  toggleModal={toggleAuthModal}
                  apiCall={addAuthPerson}
                />
                <Table
                  columns={
                    traderInformation?.corporateAccountOpeningData.stage === 'PREPARING'
                      ? authPersonTable
                      : authPersonTable.filter(item => item.key !== 'action')
                  }
                  dataSource={
                    traderInformation !== null ? traderInformation.authorizedPersonDataList : []
                  }
                  size={'large'}
                  bordered
                  style={{ shaodw: '0 0 5px solid black', marginBottom: '1rem' }}
                  scroll={{
                    x: 'max-content',
                  }}
                  rowClassName={record => record.modificationType}
                />
                {traderInformation?.corporateAccountOpeningData.stage === 'PREPARING' && (
                  <div style={{ textAlign: 'right' }}>
                    <Button type={'dashed'} icon={<PlusCircleOutlined />} onClick={toggleAuthModal}>
                      Add
                    </Button>
                  </div>
                )}
              </Panel>

              {/* Company Owner List */}
              <Panel header={'Company Owner'} key={'8'} forceRender>
                <ModalForm
                  title={'Add Company Owner'}
                  formItems={companyOwnerFormFields}
                  open={openCompanyModal}
                  toggleModal={toggleCompanyModal}
                  apiCall={addCompanyOwner}
                />
                <Table
                  columns={
                    traderInformation?.corporateAccountOpeningData.stage === 'PREPARING'
                      ? companyOwnerTable
                      : companyOwnerTable.filter(item => item.key !== 'action')
                  }
                  dataSource={traderInformation !== null ? traderInformation.companyDataList : []}
                  size={'large'}
                  bordered
                  style={{ shaodw: '0 0 5px solid black', marginBottom: '1rem' }}
                  scroll={{
                    x: 'max-content',
                  }}
                  rowClassName={record => record.modificationType}
                />
                {traderInformation?.corporateAccountOpeningData.stage === 'PREPARING' && (
                  <div style={{ textAlign: 'right' }}>
                    <Button
                      type={'dashed'}
                      icon={<PlusCircleOutlined />}
                      onClick={toggleCompanyModal}
                    >
                      Add
                    </Button>
                  </div>
                )}
              </Panel>
            </Collapse>

            {/* Group of buttons */}
            <Space
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItem: 'center',
                marginTop: '2rem',
              }}
            >
              <Space size={'middle'}>
                <Button type="default" size={'large'} onClick={goBack}>
                  <ArrowLeftOutlined /> Back
                </Button>
                <Button
                  type="primary"
                  danger
                  size={'large'}
                  onClick={() => setClickType('delete')}
                  loading={loading}
                  style={
                    traderInformation &&
                    traderInformation.corporateAccountOpeningData.stage !== 'APPROVED'
                      ? {}
                      : { display: 'none' }
                  }
                >
                  Delete
                </Button>
              </Space>
              <Space size={'middle'}>
                <Button
                  type="dashed"
                  size={'large'}
                  // htmlType="submit"
                  style={
                    user.role == 'CHECKER' ||
                    (traderInformation &&
                      traderInformation.corporateAccountOpeningData.stage !== 'PREPARING')
                      ? { display: 'none' }
                      : {}
                  }
                  loading={loading}
                  onClick={() => handleSave()}
                >
                  Save
                </Button>
                <Button
                  type="primary"
                  key="submit"
                  htmlType="submit"
                  size={'large'}
                  // onClick={() => {
                  //   setClickType('submit');
                  // }}
                  style={
                    user.role == 'CHECKER' ||
                    (traderInformation &&
                      traderInformation.corporateAccountOpeningData.stage === 'SUBMITTED') ||
                    (traderInformation &&
                      traderInformation.corporateAccountOpeningData.stage === 'APPROVED')
                      ? { display: 'none' }
                      : {}
                  }
                  loading={loading}
                >
                  Submit
                </Button>
                <Button
                  type="primary"
                  size={'large'}
                  onClick={() => {
                    setClickType('approve');
                  }}
                  style={
                    user.role != 'MAKER' &&
                    traderInformation &&
                    traderInformation.corporateAccountOpeningData.stage === 'SUBMITTED'
                      ? {}
                      : { display: 'none' }
                  }
                  loading={loading}
                >
                  Approve
                </Button>
              </Space>
            </Space>
          </Form>
        </Space>
      </Card>
    </>
  );
}
